import { useTranslation } from "react-i18next";
import { buildThemeClasses } from "../theme";

// For sub-landing items that aren't tabular CRUD yet (live views, chat, etc.).
// Renders an explanatory placeholder with the planned capabilities so the
// surface is navigable. Backend / real UI comes later.

interface PlaceholderSectionProps {
  title: string;
  subtitle?: string;
  icon?: string;
  bullets?: string[];
}

export default function PlaceholderSection({
  title,
  subtitle,
  icon,
  bullets = [],
}: PlaceholderSectionProps) {
  const { t } = useTranslation("common");
  const tc = buildThemeClasses();

  return (
    <div className="h-full w-full overflow-y-auto p-6">
      <div className="mx-auto max-w-3xl">
        <div className="mb-6 flex items-center gap-3">
          {icon && (
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500/15 text-primary-500">
              <i className={`${icon} text-xl`} />
            </span>
          )}
          <div>
            <h1 className={`text-xl font-bold ${tc.text}`}>{title}</h1>
            {subtitle && <p className={`text-sm ${tc.textSecondary}`}>{subtitle}</p>}
          </div>
        </div>

        <div
          className={`rounded-2xl border border-dashed p-10 text-center ${tc.cardBorder} ${tc.cardBg}`}
        >
          <i className={`${icon ?? "ri-flashlight-line"} mb-3 text-4xl text-primary-500`} />
          <p className={`text-sm ${tc.textSecondary}`}>{t("nuvexAccess.placeholder")}</p>

          {bullets.length > 0 && (
            <ul className="mx-auto mt-6 max-w-md space-y-2 text-left">
              {bullets.map((b) => (
                <li key={b} className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />
                  <span className={`text-sm ${tc.text}`}>{b}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
